import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { ServiceActivityResponseDataType } from '../@types';
import { getServiceActivityMonitorData } from '../api/services';
import { ServiceActivityMonitorKey } from '../configs/services';

export const useGetServiceActivityMonitorData = (refreshEnabled: boolean): UseQueryResult<ServiceActivityResponseDataType[]> => {
  return useQuery({
    queryKey: [ServiceActivityMonitorKey],
    queryFn: () => getServiceActivityMonitorData(),
    refetchInterval: refreshEnabled ? 2 * 60 * 1000 : false
  });
};